export default __webpack_public_path__ + "static/media/NC_500x500.197619ee.png";